import { createFileRoute, redirect } from '@tanstack/react-router';

import { PlayerPage } from '@/pages/player';
import { courseQueries } from '@/entities/course';

type PlayerSearch = {
  courseId?: string;
  contentId?: string;
};

export const Route = createFileRoute('/_user/courses/plyer')({
  validateSearch: (search: Record<string, unknown>): PlayerSearch => {
    const courseId =
      typeof search.courseId === 'string' ? search.courseId : undefined;
    const contentId =
      typeof search.contentId === 'string' ? search.contentId : undefined;

    return { courseId, contentId };
  },
  loaderDeps: ({ search: { courseId, contentId } }) => ({
    courseId,
    contentId,
  }),
  loader: async ({ context: { queryClient }, deps: { courseId, contentId } }) => {
    if (!courseId || !contentId) {
      return { course: null };
    }

    const course = await queryClient.ensureQueryData(
      courseQueries.detail(courseId),
    );
    const content = course?.contents.find(
      (courseContent) => courseContent.id === contentId,
    );
    if (content?.content_type === 'quiz') {
      throw redirect({
        to: '/courses/quiz',
        search: { courseId, contentId, quizId: content?.quizzes[0]?.id ?? '' },
      });
    }

    return { course };
  },
  component: PlayerPage,
});
